import { observer } from 'mobx-react';

export const TextCell = observer(({ text, emptyText }: { text: string; emptyText?: string }) => {
  return <div className="text-truncate">{text || emptyText || '-'}</div>;
});
